import * as SurveyCore from "survey-core";
import SetLeadMaxLengthAndValue from "./common/SetLeadMaxLengthAndValue";
import SetContactMaxLengthAndValue from "./common/SetContactMaxLengthAndValue";
import i18next from "../../common/localization/i18n";
import FormStateParams from "../interfaces/FormStateParams";
import { SupportedCRM } from "../../common/enums/SupportedCRM";
import SetMapperAttributes from "../../common/helpers/SetMapperAttributes";
import { EntityType } from "../../common/enums/EntityType";

function CommentToolbox(formStateParams: FormStateParams) {
  SurveyCore.Serializer.addProperty("comment", {
    name: "crmMaxLength",
    type: "number",
    default: 1,
    isSerializable: true,
    visible: false,
  });
  SurveyCore.Serializer.addProperty("comment", {
    name: "crmContactMaxLength",
    type: "number",
    default: 1,
    isSerializable: true,
    visible: false,
  });
  SurveyCore.Serializer.addProperty("comment", {
    name: "crmLeadMaxLength",
    type: "number",
    default: 1,
    isSerializable: true,
    visible: false,
  });

  SurveyCore.Serializer.addProperty("comment", {
    name: "contactMap",
    displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.CONTACT_MAP"),
    isRequired: false,
    category: "toolboxMapperCategory",
    type: "dropdown",
    isSerializable: true,
    onPropertyEditorUpdate: (obj: any, editor: any) => {
      editor.allowClear = true;
    },
    onSetValue: (obj: any, value: any) => {
      SetContactMaxLengthAndValue(obj, value, "contact", "textArea");
    },
    choices: (obj: any, choicesCallback: any) => {
      if (!choicesCallback) return;
      SetMapperAttributes("textArea", choicesCallback, formStateParams, EntityType.Contact, obj);
    },
    visibleIndex: 1,
  });

  if (formStateParams.supportedCRM === SupportedCRM.MSCRM) {
    SurveyCore.Serializer.addProperty("comment", {
      name: "leadMap",
      displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.LEAD_MAP"),
      isRequired: false,
      category: "toolboxMapperCategory",
      type: "dropdown",
      isSerializable: true,
      onPropertyEditorUpdate: (obj: any, editor: any) => {
        editor.allowClear = true;
      },
      onSetValue: (obj: any, value: any) => {
        SetLeadMaxLengthAndValue(obj, value, "lead", "textArea");
      },
      choices: (obj: any, choicesCallback: any) => {
        if (!choicesCallback) return;
        SetMapperAttributes("textArea", choicesCallback, formStateParams, EntityType.Lead, obj);
      },
      visibleIndex: 1,
    });
  }

  SurveyCore.Serializer.addProperty("comment", {
    name: "overrideInCrmMap",
    displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.OVERRIDE_IN_CRM"),
    isRequired: false,
    category: "toolboxMapperCategory",
    type: "boolean",
  });
}

export default CommentToolbox;
